export function generateRejectedTaskEmail() {
  const REJECTED_TITLE = 'Tu Task no puede ser realizada';

  return `
    <table width="100%" cellspacing="0" cellpadding="0" style="background-color: #f3f4f6; font-family: Arial, 'Helvetica Neue', sans-serif;">
        <tr>
            <td align="center" style="padding: 20px 0;">
                <table width="100%" cellspacing="0" cellpadding="0" style="max-width: 600px; border-radius: 10px; overflow: hidden; background-color: white">
                    <tr>
                        <td>
                            <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/email-top-rejected.png" alt="Tasky Header" width="100%" style="display: block; max-width: 100%;">
                        </td>
                    </tr>
                    <tr>
                        <td bgcolor="#ffffff" style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;">
                            <table width="100%" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td style="padding: 40px 20px 20px;">
                                        <h1 style="text-align: center; color: #333333; margin-top: 0; margin-bottom: 40px;">${REJECTED_TITLE}</h1>

                                        <p style="color: #333333; font-size: 18px; margin-bottom: 30px;">Lo sentimos! No podemos aceptar tu Task ahora mismo, pero puedes volver a intentarlo cuando quieras.</p>

                                        <table width="100%" cellspacing="0" cellpadding="0" bgcolor="#8B5CF6" style="margin-top: 40px; padding: 20px; border-radius: 10px;">
                                            <tr>
                                                <td align="center">
                                                    <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/tasky-logo-dark-theme.png" alt="Tasky Logo" width="80" style="display: block; margin: 0 auto;">
                                                    <div style="margin-top: 20px;">
                                                        <a href="https://www.instagram.com/tasky.cl" style="margin: 0 10px; outline: none; text-decoration: none;">
                                                            <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/instagram-icon.png" alt="Instagram" width="24">
                                                        </a>
                                                        <a href="https://www.linkedin.com/company/taskyapp/" style="margin: 0 10px; outline: none; text-decoration: none;">
                                                            <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/linkedin-icon.png" alt="LinkedIn" width="24">
                                                        </a>
                                                        <a href="https://www.tiktok.com/@tasky.cl" style="margin: 0 10px; outline: none; text-decoration: none;">
                                                            <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/tiktok-icon.png" alt="TikTok" width="24">
                                                        </a>
                                                    </div>
                                                    <p style="color: #ffffff; font-size: 11px; margin-top: 10px;">Pide tu Task y universitarios resuelven</p>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
  `;
}
